import storage from "./storage"

class Account {
    constructor() {
        console.log(storage.get("user"))
    }

    // return the ID of the current user
    static ID() {
    }
}

export default Account



// WEBPACK FOOTER //
// ./src/account.js